// 登录接口
import { Login, SearchMyInformation, fetchGetMenu } from "../../api/user";
import {
  getToken,
  setToken,
  removeToken,
  getInfo,
  setInfo,
  removeInfo,
  setTopNav,
  getTopNav,
  setMenuBar,
  getMenuBar,
  removeUserHeadPhoto,
  removeMenuBar,
  getUserHeadPhoto
} from "@/utils/auth";
import { initMenu } from "../../utils/permission";
const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getInfo(),
    isTrue: "true"
  };
};

const state = {
  UserHeadPhoto: getUserHeadPhoto(),
  loginsInfo: { dialogVisible: false },
  certificationInfo: { dialogVisible: false },
  registeredInfo: { dialogVisible: false },
  ForgetPassword: { dialogVisible: false },
  ResetPassword: { dialogVisible: false },
  axiosCancelArr: [],
  token: getToken(),
  userInfo: getInfo(),
  TopNav: getTopNav(),
  userData: {},
  // 我的消息
  myNewInfo: {},
  listQuery: {
    PageIndex: 1,
    TotalCount: 1,
    page_count: 1, // 总页数
    PageSize: 10,
    AllowPaging: true
  },
  //
  menuTree: getMenuBar() || []
};
const mutations = {
  // 设置头像数据
  HEAD_PHOTO: (state, UserHeadPhoto) => {
    state.UserHeadPhoto = UserHeadPhoto;
  },
  ADD_VISIBLE: (state, dialogVisible) => {
    state.loginsInfo.dialogVisible = dialogVisible;
  },
  ADD_CERTIFITION: (state, dialogVisible) => {
    state.certificationInfo.dialogVisible = dialogVisible;
  },
  ADD_REGIN: (state, dialogVisible) => {
    state.registeredInfo.dialogVisible = dialogVisible;
  },
  // 取消多次请求
  PUSH_CANCEL(state, cancel) {
    state.axiosCancelArr.push(cancel.cancelToken);
  },

  CLEAR_CANCEL(state) {
    state.axiosCancelArr.forEach(e => {
      e && e();
    });
    state.axiosCancelArr = [];
  },
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  // Token
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  // userInfo
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  // 动态获取 用户信息
  SET_USERDATA: (state, userData) => {
    state.userData = userData;
  },
  // 获取我的消息
  SET_MYNEWINFO: (state, myNewInfo) => {
    console.log(myNewInfo.Data);
    state.myNewInfo = { ...myNewInfo, ...state.myNewInfo };
  },
  // 修改分页数据
  SET_PAGING: (state, PageIndex) => {
    state.listQuery.PageIndex = PageIndex;
  },
  // 设置 路由
  SET_MENU: (state, menu) => {
    state.menuTree = [...menu];
  }
};
const actions = {
  // 设置头像
  HeadPhoto({ commit }, UserHeadPhoto) {
    commit("HEAD_PHOTO", UserHeadPhoto);
  },
  addErrorlog({ commit }, login) {
    commit("ADD_VISIBLE", login);
  },
  pushCancel({ commit }, cancel) {
    commit("PUSH_CANCEL", cancel);
  },
  clearCancel({ commit }) {
    commit("CLEAR_CANCEL");
  },
  // getMenu
  getMenu({ commit }, mun) {
    return new Promise((resolve, reject) => {
      fetchGetMenu()
        .then(res => {
          const oRouter = initMenu(res.Data);
          commit("SET_MENU", oRouter);
          // 保存到本地
          setMenuBar(oRouter);
          resolve(oRouter);
        })
        .finally(() => {
          //
        })
        .catch(error => {
          console.log("error", error);
          reject(error);
        });
    });
  },
  // user login
  login({ commit }, userInfo) {
    console.log(userInfo);
    const { phone, passworld } = userInfo;
    return new Promise((resolve, reject) => {
      Login({ LoginCode: phone, LoginPwd: passworld })
        .then(async res => {
          console.log(res, "测试");
          const { Data } = res;
          if (Data && Data.User != null) {
            // 设置Token
            commit("SET_TOKEN", Data.User.Token);
            // 保存Token
            setToken(Data.User.Token);
            // 设置用户信息
            commit("SET_USERINFO", Data.User);
            // 保存用户信息
            setInfo(Data.User);
            resolve(res.Data);
          } else {
            resolve(res.Msg);
          }
        })
        .catch(error => {
          reject(error);
          console.log("error", error);
        });
    });
  },
  // 登出 移除Token
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          removeUserHeadPhoto();
          removeMenuBar();
          commit("RESET_STATE");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 移除Token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      removeInfo();
      commit("RESET_STATE");
      resolve();
    });
  },
  // 单独，请求用户信息的接口
  getUserData({ commit }) {
    return new Promise(resolve => {
      SearchMyInformation().then(res => {
        // console.log(res);
        commit("SET_USERDATA", res.Data);
        // 设置用户信息
        commit("SET_USERINFO", res.Data);
        // 保存用户信息
        setInfo(res.Data);
        resolve(res.Data);
      });
    });
  },
  // 发送请求数据 个人中心消息数据
  getSearchMyMessage({ commit, state }, listQuery) {
    return new Promise((resolve, reject) => {
      //
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js